import React from 'react';
import { useSelector } from 'react-redux';
import CustomerInformation from 'pages/order-details/CustomerInformation';
import Button from 'components/Button';
import COLORS from 'shared/constants/colors';
import { imagesBaseURL } from 'shared/requests';
import Image from 'components/Image';
import { USD_TO_CAD_CONVERSION_RATE } from 'constants/currency';
import {
  Container,
  ShippingPricing,
} from 'styles/pages/order-details/shippingInfo';

const getShippingPackageImage = (order) => {
  if (order?.PrintProvider === 'US') {
    return `${imagesBaseURL}/Images/shipping-methods/USPS_First_Class_Mail.png?v=1594313218`;
  }

  if (order?.PrintProvider === 'CA') {
    if (order?.CountryString === 'CA') {
      return `${imagesBaseURL}/Images/shipping-methods/StandardCAtoCA.png?v=1605562045`;
    } else if (order?.CountryString === 'US') {
      return `${imagesBaseURL}/Images/shipping-methods/StandardCAtoUS.png?v=1605562045`;
    }
  }

  return `${imagesBaseURL}/Images/shipping-methods/StandardCAtoINT.png?v=1605562045`;
};

const ShippingInfo = ({ order, shippingCostInfo = {}, onOrderSummary }) => {
  const currency = useSelector((state) => state?.currency?.value);
  return (
    <Container>
      <CustomerInformation orderDetail={order} showEdit={false} />
      <ShippingPricing>
        <h1>Shipping Speeds and Pricing</h1>
        <div>
          <p>
            Big Oven Tees takes {shippingCostInfo.minDays}-
            {shippingCostInfo.maxDays}
            &nbsp;business days to fulfill your order(s), in addition to
            shipping times. Shipping times and costs vary based on the shipping
            method and the location to which your order(s) will be delivered.
          </p>
          <br />
          <p style={{ color: '#ff6600' }}>
            Big Oven Tees offers Print-on-Demand + drop shipping services.
            During order submission, from time to time shipping services from
            our shipping partners may not be able to service the shipping option
            selected. In the case when standard and/or chosen shipping option is
            not available for the destination, shipping fees may be subject to
            change. Should this happen, you will be contacted by Big Oven Tees
            Client Support Team for further steps to be taken to ensure timely
            delivery of your order.
          </p>
          <div>
            <div>
              <Image
                src={getShippingPackageImage(order)}
                alt="Shipping"
                aspectRatio={16 / 13}
              />
              <h5>
                $
                {shippingCostInfo.cost
                  ? currency === 'USD'
                    ? Number(shippingCostInfo.cost).toFixed(2)
                    : (
                        Number(shippingCostInfo.cost) *
                        USD_TO_CAD_CONVERSION_RATE
                      ).toFixed(2)
                  : 0}
                &nbsp; {currency}
              </h5>
            </div>
          </div>
          <Button
            containerStyle={{
              backgroundColor: COLORS.GREEN,
              color: COLORS.WHITE,
              padding: '5px 16px',
              textTransform: 'capitalize',
            }}
            onClick={onOrderSummary}
            variant="text"
            title="Continue to order summary"
          />
        </div>
      </ShippingPricing>
    </Container>
  );
};

export default ShippingInfo;
